
export const DIMBO_CONSTANT = {
    // Configs
    I18N_ENDPOINT: '/assets/i18n',
    CONFIG_ENDPOINT: '/assets/config/config.json',

    //varibales 
     
    // Urls
    AUTHENTICATE_LOGIN_LDAP : '/authenticateWithLdap',
    SERVICE_COUNT : '/count/service',
    CONTRACT_COUNT : '/count/contract'
}